<script setup lang="ts">
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import ChevronLeftSVG from '@shared/assets/icon/chevron-left.svg';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import ButtonOutlined from '@/shared/components/button/ButtonOutlined.vue';
import { useCommissioningDeviceStore } from '@/modules/commissioning/stores/commissioningDeviceStore';
import { ERROR_CTA_BUTTONS } from '@/modules/commissioning/utils/error-constants';
import { useCommissioningNavStore } from '@/modules/commissioning/stores/commissioningNavStore';

const PRIMARY_BUTTONS = [ERROR_CTA_BUTTONS.TRY_AGAIN];

const props = withDefaults(
  defineProps<{
    ctaButtons?: string[];
  }>(),
  {
    ctaButtons: () => [],
  },
);

const router = useRouter();
const deviceStore = useCommissioningDeviceStore();
const commissioningNavStore = useCommissioningNavStore();

const back = () => router.go(-1);

const contactSupport = () => {
  commissioningNavStore.requestContactUsViaNavBar();
};

const tryAgain = () => {
  deviceStore.isUploadConfig = false;
  router.push({ name: 'StartCommissioning' });
};

const hasPrimaryButton = computed(() => {
  return PRIMARY_BUTTONS.some((button) => props.ctaButtons.includes(button));
});
</script>

<template>
  <div class="error-cta-container">
    <ButtonPrimary
      block
      class="error-cta-button"
      data-tn="try-again"
      @click="tryAgain"
      v-if="ctaButtons.includes(ERROR_CTA_BUTTONS.TRY_AGAIN)"
    >
      Try Again
    </ButtonPrimary>

    <template v-if="hasPrimaryButton">
      <ButtonOutlined
        block
        class="error-cta-button"
        data-tn="contact-support"
        @click="contactSupport"
        v-if="ctaButtons.includes(ERROR_CTA_BUTTONS.CONTACT_SUPPORT) && hasPrimaryButton"
      >
        Contact Support
      </ButtonOutlined>
    </template>
    <template v-else>
      <ButtonPrimary
        block
        class="error-cta-button"
        data-tn="contact-support"
        @click="contactSupport"
        v-if="ctaButtons.includes(ERROR_CTA_BUTTONS.CONTACT_SUPPORT)"
      >
        Contact Support
      </ButtonPrimary>
    </template>

    <ButtonOutlined block class="error-cta-button" @click="back">
      <template #iconLeft>
        <ChevronLeftSVG />
      </template>
      Back
    </ButtonOutlined>
  </div>
</template>

<style scoped lang="less">
</style>